import "bootstrap/dist/css/bootstrap.min.css";
import BarGraph from "components/graphs/BarGraph";
import React from "react";
import { Card, Col } from "react-bootstrap";

const GNSSRangeDomainAccuracyCard = ({ innerRef, data }) => {
  const renderGraphs = (constellations) => {
    return constellations.map((constellation, index) => (
      <React.Fragment key={index}>
        {constellation.bands.map((band, index) => (
          <React.Fragment key={index}>
            <p className="text-justify">
              Range domain accuracy for {constellation.name} {band.name}{" "}
            </p>
            <Col sm={{ span: 12, offset: 0 }} xxl={{ span: 10, offset: 1 }}>
              {band.plots.map((plot, index) => (
                <BarGraph key={index} width={400} height={400} dataset={plot} />
              ))}
            </Col>
          </React.Fragment>
        ))}
      </React.Fragment>
    ));
  };

  return (
    <>
      <Card.Title as="h6" ref={innerRef}>
        Range domain accuracy
      </Card.Title>
      <Card.Body>
        <p className="text-justify">
          The range domain accuracy is calculated using the instantaneous SIS
          user range error, representing the difference between the pseudo-range
          measured at a given location and the expected pseudo-range as derived
          from the navigation message. This parameter is calculated over a
          24-hours interval.
        </p>
        {renderGraphs(data.constellations)}
      </Card.Body>
    </>
  );
};

export default React.memo(
  React.forwardRef((props, ref) => (
    <GNSSRangeDomainAccuracyCard innerRef={ref} {...props} />
  ))
);
